export const APP_NAME = 'StadtLand.Funk';

export const APP_VARIANT_IDENTIFIER =
  process.env.EXPO_PUBLIC_APP_VARIANT_IDENTIFIER;

export const APNS_PUSH_PLATFORM =
  process.env.EXPO_PUBLIC_APNS_PUSH_PLATFORM ?? 'APNS_DEV';

export const APP_URL = process.env.EXPO_PUBLIC_KEYCLOAK_WEB_REDIRECT_URL;
